import React, { Component } from 'react';
import PropTypes            from 'prop-types';
import { Form, Select }     from 'semantic-ui-react';

import { toTitleCase }      from 'utils/strings';

// --------------------------------------------------------
// Helpers
// --------------------------------------------------------

function getOptions(events) {
  return events.map(e => ({ text: toTitleCase(e), value: e }));
}

// --------------------------------------------------------
// Component Definition
// --------------------------------------------------------

class EventSelector extends Component {

  // construction
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  // handlers
  handleChange(evt, { value }) {
    const { onChange } = this.props;
    onChange(value);
  }

  // rendering
  render() {
    const { events, value } = this.props;
    const placeholder       = 'Select an Event';
    const options           = getOptions(events);

    return (
      <Form.Field control={ Select }
                  placeholder={ placeholder }
                  options={ options }
                  value={ value }
                  onChange={ this.handleChange } />
    );
  }
}

// --------------------------------------------------------
// Prop Types
// --------------------------------------------------------

EventSelector.propTypes = {
  events:     PropTypes.array.isRequired,
  value:      PropTypes.string.isRequired,
  onChange:   PropTypes.func.isRequired
};

// --------------------------------------------------------
// Exports
// --------------------------------------------------------

export default EventSelector;
